import {Helmet} from '@dr.pogodin/react-helmet';
import {BreadcrumbType} from 'platform/components';

import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {formatDocumentTitle} from '@dms/shared';

import {ParkingSectorForm} from './components/ParkingSectorForm';

const breadcrumbs: BreadcrumbType[] = [
  {
    label: i18n.t('page.vehicleSettings.labels.parking'),
    href: settingsRoutes.vehicleParking,
  },
];

export function VehicleParkingAdd() {
  return (
    <>
      <Helmet
        title={formatDocumentTitle(
          i18n.t('page.vehicleSettings.labels.newParkingSector'),
          i18n.t('page.vehicleSettings.labels.parking'),
          i18n.t('page.settings.labels.title')
        )}
      />
      <SettingsTemplate
        header={{breadcrumbs}}
        data-testid={testIds.settings.vehicleParkingAdd('modal')}
      >
        <ParkingSectorForm />
      </SettingsTemplate>
    </>
  );
}
